import api from 'Application/api/api';

const reopenRfep = (signal, values) =>
	api.post('/tenders/reopen', values, {
		signal,
	});

export default reopenRfep;
